export var absoluteCenteredStyle = "\n  position: absolute !important;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n";
export var selfCenteredStyle = "\n  margin-left: auto;\n  margin-right: auto;\n";